// extracted by mini-css-extract-plugin
module.exports = {"giftAction":"product-gift-addtobag_giftAction__tMxYF"};